import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";

export const MessagesTab = () => {
  const [msgs, setMsgs] = useState(null);
  const load = () => api.get("/admin/messages").then((r) => setMsgs(Array.isArray(r.data) ? r.data : [])).catch(() => setMsgs([]));
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/admin/messages/${id}`);
    load();
  };
  if (msgs === null) return <p className="owner-empty">Loading…</p>;
  if (!msgs.length) return <p className="owner-empty" data-testid="owner-messages-empty">No messages yet.</p>;
  return (
    <div className="bk-grid">
      {msgs.map((m) => (
        <article key={m.id} className="owner-card" data-testid={`owner-message-${m.id}`}>
          <p className="bk-when">{format(parseISO(m.created_at), "MMM d, h:mm a")} · {m.subject}</p>
          <h3>{m.name}</h3>
          <p className="bk-meta"><a href={`mailto:${m.email}`}>{m.email}</a></p>
          <p className="bk-notes">{m.message}</p>
          <div className="bk-actions">
            <a className="cta sm" href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`}>Reply</a>
            <button type="button" className="icon-btn" onClick={() => remove(m.id)} aria-label="Delete message"
              data-testid={`owner-message-delete-${m.id}`}><Trash2 size={16} /></button>
          </div>
        </article>
      ))}
    </div>
  );
};
